// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-K":"K_outdoor-recreation-K__GQe9U"};